var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "10.5638in",
    height: "9.492in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1178.54 1058.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M589.27 0c208.77,0 363.44,58.09 464.01,174.64 83.51,96.94 125.26,215.67 125.26,355.45 0,155.03 -53.66,279.28 -152.49,380.87 -4.58,4.71 -6.8,13.06 -1.32,17.87 24.41,21.41 84.31,74.68 111.09,96.4 7.97,6.46 5.23,20.31 -4.53,20.52 -69.32,1.5 -429.15,10.99 -526.05,12.98 -145.2,2.98 -259.24,-21.78 -342.38,-65.35 -83.14,-43.57 -147.77,-107.11 -193.88,-190.61 -46.11,-83.14 -68.98,-174.28 -68.98,-272.67 0,-158.3 50.47,-286.1 151.77,-383.77 101.3,-97.67 247.25,-146.32 437.5,-146.32zm218.13 600.63c-38.42,0 -69.56,-30.79 -69.56,-68.76 0,-37.98 31.14,-68.76 69.56,-68.76 38.42,0 69.56,30.79 69.56,68.76 0,37.98 -31.14,68.76 -69.56,68.76zm-427.2 0c-38.42,0 -69.56,-30.79 -69.56,-68.76 0,-37.98 31.14,-68.76 69.56,-68.76 38.42,0 69.56,30.79 69.56,68.76 0,37.98 -31.14,68.76 -69.56,68.76zm209.07 -2.5c-38.42,0 -69.56,-30.79 -69.56,-68.76 0,-37.98 31.14,-68.76 69.56,-68.76 38.42,0 69.56,30.79 69.56,68.76 0,37.98 -31.14,68.76 -69.56,68.76zm-0.36 -402.07c-144.5,0 -252.7,31.59 -324.23,94.76 -71.89,63.54 -107.83,143.05 -107.83,239.27 0,95.13 35.94,174.28 108.2,237.81 72.25,63.17 182.26,94.76 330.03,94.76 139.42,0 245.08,-31.95 316.6,-95.49 71.89,-63.54 107.83,-142.69 107.83,-237.09 0,-96.21 -35.58,-175.73 -107.11,-239.27 -71.53,-63.18 -179.36,-94.76 -323.5,-94.76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.770115dc1d15dc0839ff500ca2454c54.svg";
export { ForwardRef as ReactComponent };